import { React, useEffect, useState } from 'react';
import { SelectComponent } from 'component/Select';
import { getCustomers } from 'api/CustomersApi';
import { axiosWrapper } from 'utils/Helper';

export const UserDefaultCustomer = (props) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    axiosWrapper(() => {
      getCustomers(1, true)
        .then((res) => {
          const results = res.data.results ?? res.data;
          const list = Array.isArray(results) ? results : [];
          setOptions(
            list.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
        })
        .catch((err) => console.error(err));
    });
  }, []);

  const value = props.userInfo?.default_customer;
  const valueId = value?.id ?? value;

  const handleSelect = (selected) => {
    props.setUserInfo((prev) => ({
      ...prev,
      default_customer: selected?.value ?? selected ?? null,
    }));
  };

  return (
    <div className="select-wrapper w-100" style={{ gap: '0' }}>
      <span className="label" style={{ marginTop: '10px' }}>
        Default customer (for OPS)
      </span>
      <SelectComponent
        className="w-100"
        placeholder="Select..."
        value={
          valueId
            ? {
                value: options.find((option) => option.value === valueId)?.value ?? valueId,
                label: options.find((option) => option.value === valueId)?.label ?? '',
              }
            : null
        }
        options={options}
        handleSelect={handleSelect}
        isDisabled={!props.hasEditPermission}
        isSearchable
      />
    </div>
  );
};
